module.exports = __webpack_public_path__ + "static/media/TrashJoes-square.eb4faa3f.jpg";